// File: apps/trading-web/src/components/BonusCenter.ts
import { getCurrencySymbol } from '../../../shared-web/display-currency';

export function renderBonusCenter(bonuses: any[] = [], progress: any = null, currency: string = "USD"): string {
  const active = progress?.active_bonuses?.[0] || progress;
  const currentTurnover = active?.completed_turnover_cents != null
    ? (Number(active.completed_turnover_cents) / 100).toFixed(2)
    : (active ? parseFloat(active.current_turnover || '0').toFixed(2) : '0.00');
  const requiredTurnover = active?.required_turnover_cents != null
    ? (Number(active.required_turnover_cents) / 100).toFixed(2)
    : (active ? parseFloat(active.required_turnover || '0').toFixed(2) : '0.00');
  const pct = Math.min(100, Math.round((parseFloat(currentTurnover) / (parseFloat(requiredTurnover) || 1)) * 100));

  const currSym = getCurrencySymbol(currency);
  const now = Date.now();
  const FORTY_EIGHT_HOURS_MS = 48 * 3600 * 1000;

  const claimedCampaignNames = new Set<string>();
  const claimedCampaignIds = new Set<string>();

  // Extract claimed bonus grants and enforce 48-hour visibility lifecycle
  const activeBonusGrants = (progress?.active_bonuses || []);
  const claimedCards = activeBonusGrants
    .filter((grant: any) => {
      if (!grant) return false;
      const createdAtMs = grant.created_at ? new Date(grant.created_at).getTime() : now;
      const ageMs = now - createdAtMs;
      // Retain for 48 hours, then remove completely from UI
      return ageMs <= FORTY_EIGHT_HOURS_MS;
    })
    .map((grant: any) => {
      const gName = String(grant.campaign_name || '').toLowerCase();
      if (gName) claimedCampaignNames.add(gName);
      if (grant.campaign_id) claimedCampaignIds.add(String(grant.campaign_id));
      if (grant.grant_id) claimedCampaignIds.add(String(grant.grant_id));

      const createdAtMs = grant.created_at ? new Date(grant.created_at).getTime() : now;
      const ageMs = Math.max(0, now - createdAtMs);
      const remainingHours = Math.max(1, Math.ceil((FORTY_EIGHT_HOURS_MS - ageMs) / (3600 * 1000)));

      const title = grant.campaign_name || '100% First Deposit Match';
      const grantedAmt = grant.granted_amount_cents != null
        ? `${currSym}${(Number(grant.granted_amount_cents) / 100).toFixed(2)}`
        : '';
      const reqTurnover = grant.required_turnover_cents != null
        ? `${currSym}${(Number(grant.required_turnover_cents) / 100).toFixed(2)}`
        : '';

      return `
        <div class="bonus-card bonus-card-claimed" style="background: linear-gradient(135deg, #131b2e 0%, #0c1220 100%); border: 1px solid rgba(245, 158, 11, 0.4); border-radius: 14px; padding: 16px; margin-bottom: 12px; box-shadow: 0 8px 24px rgba(0,0,0,0.3); opacity: 0.95;">
          <div style="display: flex; justify-content: space-between; align-items: flex-start; gap: 8px; margin-bottom: 10px;">
            <div style="display: flex; align-items: center; gap: 10px;">
              <div style="width: 40px; height: 40px; border-radius: 10px; background: rgba(245, 158, 11, 0.15); border: 1px solid rgba(245, 158, 11, 0.35); display: flex; align-items: center; justify-content: center; font-size: 20px; flex-shrink: 0;">
                🎁
              </div>
              <div>
                <div style="display: flex; align-items: center; gap: 6px; flex-wrap: wrap;">
                  <h4 style="margin: 0; font-size: 15px; font-weight: 800; color: #ffffff;">${title}</h4>
                  <span style="font-size: 9px; font-weight: 800; background: rgba(245, 158, 11, 0.2); color: #fbbf24; border: 1px solid rgba(245, 158, 11, 0.4); padding: 2px 6px; border-radius: 4px;">USED</span>
                </div>
                <span style="font-size: 11px; color: #fbbf24; font-weight: 600;">CLAIMED WITH DEPOSIT</span>
              </div>
            </div>
            <span style="font-size: 10px; font-weight: 800; background: rgba(245, 158, 11, 0.15); color: #fbbf24; border: 1px solid rgba(245, 158, 11, 0.3); padding: 3px 8px; border-radius: 6px; white-space: nowrap;">
              ⏳ ${remainingHours}h Left in Vault
            </span>
          </div>

          <p style="font-size: 12px; color: #cbd5e1; line-height: 1.45; margin: 0 0 12px 0;">
            Promotional bonus ${grantedAmt ? `(${grantedAmt}) ` : ''}has been successfully claimed with your deposit. Active in wagering turnover tracker.
          </p>

          <!-- Perks list -->
          <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 6px; margin-bottom: 14px; font-size: 11px; color: #94a3b8;">
            <div style="display: flex; align-items: center; gap: 5px;">
              <span style="color: #34d399; font-weight: bold;">✓</span> Instant Credit Applied
            </div>
            <div style="display: flex; align-items: center; gap: 5px;">
              <span style="color: #34d399; font-weight: bold;">✓</span> 0% Extra Fees
            </div>
            <div style="display: flex; align-items: center; gap: 5px;">
              <span style="color: #34d399; font-weight: bold;">✓</span> 24/7 OTC Liquidity
            </div>
            <div style="display: flex; align-items: center; gap: 5px;">
              <span style="color: #34d399; font-weight: bold;">✓</span> Turnover: ${reqTurnover || 'Active'}
            </div>
          </div>

          <button disabled style="width: 100%; padding: 11px; border-radius: 8px; background: rgba(51, 65, 85, 0.45); color: #94a3b8; border: 1px solid rgba(148, 163, 184, 0.2); font-size: 13px; font-weight: 700; cursor: not-allowed; display: flex; align-items: center; justify-content: center; gap: 8px;">
            <span style="color: #34d399;">✓</span> Claimed with Deposit
          </button>
          <div style="font-size: 10px; color: #64748b; text-align: center; margin-top: 6px;">Single-use promotional voucher · Automatically removed after 48h</div>
        </div>
      `;
    });

  // Filter out any bonus campaigns that have already been claimed
  const unclaimedBonuses = (bonuses || []).filter((b: any) => {
    const bid = String(b.campaign_id || b.bonus_id || b.id || '');
    const bName = String(b.name || b.title || '').toLowerCase();
    if (bid && claimedCampaignIds.has(bid)) return false;
    if (bName && claimedCampaignNames.has(bName)) return false;
    if (b.status === 'USED') return false;
    return true;
  });

  const availableBonusCards = unclaimedBonuses.map((b: any) => {
    const isDepositMatch = b.bonus_type === 'DEPOSIT_MATCH' || b.bonus_type === 'TIERED_DEPOSIT' || (b.min_deposit_cents && b.min_deposit_cents > 0);
    const multiplier = b.turnover_multiplier || (b.percentage_bps ? Math.round(Number(b.percentage_bps)/100) : 35);
    const title = b.name || b.title || '100% First Deposit Match';
    const desc = b.description || 'Boost your starting equity with an instant 100% credit on your next cashier deposit.';
    const bid = String(b.campaign_id || b.bonus_id || b.id || '');

    return `
      <div class="bonus-card" style="background: linear-gradient(135deg, #131b2e 0%, #0c1220 100%); border: 1px solid rgba(56, 189, 248, 0.25); border-radius: 14px; padding: 16px; margin-bottom: 12px; box-shadow: 0 8px 24px rgba(0,0,0,0.3); transition: transform 0.15s, border-color 0.15s;">
        <div style="display: flex; justify-content: space-between; align-items: flex-start; gap: 8px; margin-bottom: 10px;">
          <div style="display: flex; align-items: center; gap: 10px;">
            <div style="width: 40px; height: 40px; border-radius: 10px; background: rgba(56, 189, 248, 0.15); border: 1px solid rgba(56, 189, 248, 0.3); display: flex; align-items: center; justify-content: center; font-size: 20px; flex-shrink: 0;">
              🎁
            </div>
            <div>
              <div style="display: flex; align-items: center; gap: 6px; flex-wrap: wrap;">
                <h4 style="margin: 0; font-size: 15px; font-weight: 800; color: #ffffff;">${title}</h4>
                <span style="font-size: 9px; font-weight: 800; background: rgba(16, 185, 129, 0.2); color: #34d399; border: 1px solid rgba(16, 185, 129, 0.3); padding: 2px 6px; border-radius: 4px;">ACTIVE</span>
              </div>
              <span style="font-size: 11px; color: #94a3b8; font-weight: 600;">${b.bonus_type || 'DEPOSIT_MATCH'}</span>
            </div>
          </div>
          <span style="font-size: 10px; font-weight: 800; background: rgba(56, 189, 248, 0.15); color: #38bdf8; border: 1px solid rgba(56, 189, 248, 0.3); padding: 3px 8px; border-radius: 6px; white-space: nowrap;">
            ⚡ ${multiplier}x Turnover
          </span>
        </div>

        <p style="font-size: 12px; color: #cbd5e1; line-height: 1.45; margin: 0 0 12px 0;">
          ${desc}
        </p>

        <!-- Perks list -->
        <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 6px; margin-bottom: 14px; font-size: 11px; color: #94a3b8;">
          <div style="display: flex; align-items: center; gap: 5px;">
            <span style="color: #34d399; font-weight: bold;">✓</span> Instant Credit
          </div>
          <div style="display: flex; align-items: center; gap: 5px;">
            <span style="color: #34d399; font-weight: bold;">✓</span> 0% Extra Fees
          </div>
          <div style="display: flex; align-items: center; gap: 5px;">
            <span style="color: #34d399; font-weight: bold;">✓</span> 24/7 OTC Liquidity
          </div>
          <div style="display: flex; align-items: center; gap: 5px;">
            <span style="color: #34d399; font-weight: bold;">✓</span> Fast Withdrawal
          </div>
        </div>

        <button class="btn-claim-bonus experience-action" data-bonus-id="${bid}" data-deposit-match="${isDepositMatch}" style="width: 100%; padding: 11px; border-radius: 8px; background: linear-gradient(135deg, #0284c7, #2563eb); color: #ffffff; border: none; font-size: 13px; font-weight: 700; cursor: pointer; display: flex; align-items: center; justify-content: center; gap: 8px; box-shadow: 0 4px 14px rgba(2, 132, 199, 0.35); transition: opacity 0.15s;">
          <span>🎁</span> ${isDepositMatch ? 'Deposit & Claim Bonus →' : 'Claim Bonus Now →'}
        </button>
      </div>
    `;
  });

  const allRenderedCards = [...claimedCards, ...availableBonusCards].join('');
  const totalCount = claimedCards.length + availableBonusCards.length;

  return `
    <div class="promotions-screen-container" style="padding: 16px; color: #f8fafc; font-family: -apple-system, BlinkMacSystemFont, 'Inter', sans-serif;">
      <!-- Modern Header -->
      <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px;">
        <div>
          <div style="font-size: 11px; text-transform: uppercase; letter-spacing: 0.08em; color: #38bdf8; font-weight: 700;">Promotional Vault</div>
          <h3 style="font-size: 18px; font-weight: 800; margin: 2px 0 0 0; color: #ffffff;">Bonuses & Accelerators</h3>
        </div>
        <span style="font-size: 10px; background: rgba(56, 189, 248, 0.15); color: #38bdf8; border: 1px solid rgba(56, 189, 248, 0.3); padding: 4px 10px; border-radius: 20px; font-weight: 700;">
          PROMOTIONS
        </span>
      </div>

      <!-- Turnover Progress Card -->
      <div class="turnover-progress-card" style="background: linear-gradient(135deg, rgba(30, 41, 59, 0.8), rgba(15, 23, 42, 0.95)); border: 1px solid rgba(56, 189, 248, 0.3); border-radius: 14px; padding: 16px; margin-bottom: 20px; box-shadow: 0 4px 20px rgba(0,0,0,0.35);">
        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px;">
          <div style="display: flex; align-items: center; gap: 6px;">
            <span style="font-size: 14px;">📊</span>
            <strong style="font-size: 13px; color: #f8fafc;">Active Turnover Requirement</strong>
          </div>
          <span style="font-size: 12px; font-weight: 800; color: #38bdf8; font-family: monospace;">${pct}% COMPLETED</span>
        </div>

        <!-- Progress Track -->
        <div style="width: 100%; height: 8px; background: #1e293b; border-radius: 4px; overflow: hidden; margin-bottom: 12px;">
          <div style="height: 100%; width: ${pct}%; background: linear-gradient(90deg, #0284c7, #10b981); border-radius: 4px; box-shadow: 0 0 8px rgba(16, 185, 129, 0.5); transition: width 0.3s ease;"></div>
        </div>

        <!-- 3-Column Stats -->
        <div style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 8px; background: rgba(15, 23, 42, 0.6); padding: 10px; border-radius: 8px; border: 1px solid #1e293b; text-align: center;">
          <div>
            <span style="font-size: 10px; color: #94a3b8; display: block;">Current Wager</span>
            <strong style="font-size: 12px; color: #34d399; font-family: monospace;">${currSym}${currentTurnover}</strong>
          </div>
          <div>
            <span style="font-size: 10px; color: #94a3b8; display: block;">Target Wager</span>
            <strong style="font-size: 12px; color: #f8fafc; font-family: monospace;">${currSym}${requiredTurnover}</strong>
          </div>
          <div>
            <span style="font-size: 10px; color: #94a3b8; display: block;">Unlocked</span>
            <strong style="font-size: 12px; color: #38bdf8; font-family: monospace;">${pct}%</strong>
          </div>
        </div>

        <div style="font-size: 10px; color: #64748b; margin-top: 10px; line-height: 1.4; text-align: center;">
          Completed trade volumes automatically unlock bonus equity for full on-chain cashier withdrawal.
        </div>
      </div>

      <!-- Available Bonuses Heading -->
      <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 12px;">
        <h4 style="margin: 0; font-size: 14px; font-weight: 800; color: #f8fafc; text-transform: uppercase; letter-spacing: 0.05em;">
          Deposit Campaigns & Perks
        </h4>
        <span style="font-size: 11px; color: #38bdf8; font-weight: 600;">${totalCount} Campaign${totalCount === 1 ? '' : 's'}</span>
      </div>

      <!-- Available Bonuses List -->
      <div class="bonus-campaigns-list">
        ${allRenderedCards || `
          <div style="text-align: center; padding: 32px 16px; background: #0f172a; border: 1px dashed #334155; border-radius: 12px; color: #94a3b8;">
            <span style="font-size: 28px; display: block; margin-bottom: 8px;">🎁</span>
            <strong style="color: #fff; font-size: 14px;">No active bonus campaigns available</strong>
            <p style="font-size: 11px; margin: 4px 0 0 0;">Check back soon for seasonal deposit vouchers and tournament boosts.</p>
          </div>
        `}
      </div>
    </div>
  `;
}
